import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "../../models/api-response.model";
import { Currency } from "../../models/currency.model";
import { Bank } from "../../models/bank.model";
import { CorporateContributorRequest, FundContributor, IndividualContributorRequest } from  "../../models/fund-contributor";
import { FinancialDashboardChartData } from "../../../features/fundManagement/financial-dashboard-chart/models/financial-dashboard-chart-data";
import { FinancialDashboardSummary } from "../../../features/fundManagement/financial-dashboard-chart/models/financial-dashboard-summary";
import { environment } from "../../../../environments/environment";
import { IndustryType } from "../../models/industry-type";

@Injectable({
    providedIn: 'root'
})

export class FinancialDashboardService {

    private readonly apiUrl = `${environment.apiGatewayBaseUrl}`;
    // private apiUrl1 = 'https://localhost:7254/api/Liquidity/financial-dashboard-chart';
    // private apiUrl2 = 'https://localhost:7254/api/Liquidity/financial-dashboard-chart';

    constructor(private http: HttpClient) { }

    /**
     * Get dashboard summary data for tiles
     */
    getFinancialDashboardSummary(
        startDate?: string,
        endDate?: string,
        companyId?: number
    ): Observable<ApiResponse<FinancialDashboardSummary>> {
        let params = new HttpParams();

        if (startDate) {
            params = params.set('startDate', startDate);
        }
        if (endDate) {
            params = params.set('endDate', endDate);
        }
        if (companyId) {
            params = params.set('companyId', companyId.toString());
        }

        return this.http.get<ApiResponse<FinancialDashboardSummary>>(
            `${this.apiUrl}/Liquidity/financial-dashboard-chart`,
            { params }
        );
    }

    /**
     * Get dashboard chart data (Chart.js ready)
     */
    getFinancialDashboardChartData(
        startDate?: string,
        endDate?: string,
        companyId?: number
    ): Observable<ApiResponse<FinancialDashboardChartData>> {
        let params = new HttpParams();

        if (startDate) {
            params = params.set('startDate', startDate);
        }
        if (endDate) {
            params = params.set('endDate', endDate);
        }
        if (companyId) {
            params = params.set('companyId', companyId.toString());
        }

        return this.http.get<ApiResponse<FinancialDashboardChartData>>(
            `${this.apiUrl}/Liquidity/financial-dashboard-chart`,
            { params }
        );
    }

    /**
     * Get all currencies
     */
    getAllCurrencies(): Observable<ApiResponse<Currency[]>> {
        return this.http.get<ApiResponse<Currency[]>>(
            `${this.apiUrl}/Liquidity/GetAllCurrencyList`
        );
    }

    getAllBankDetails(): Observable<ApiResponse<Bank[]>> {
        return this.http.get<ApiResponse<Bank[]>>(
            `${this.apiUrl}/Companies/banks`
        );
    }

    // Get all Industries
    getAllIndustries(): Observable<ApiResponse<Array<IndustryType>>> {
        return this.http.get<ApiResponse<Array<IndustryType>>>(
            `${this.apiUrl}/Companies/industry-types`
        );
    }

    /**
     * Get fund contributor details
     */
    getFundContributorDetails(): Observable<ApiResponse<FundContributor[]>> {
        return this.http.get<ApiResponse<FundContributor[]>>(
            `${this.apiUrl}/Liquidity/GetFundContributorDetails`
        );
    }

    addCorporateContributor(payload: CorporateContributorRequest): Observable<ApiResponse<boolean>> {
        return this.http.post<ApiResponse<boolean>>(
            `${this.apiUrl}/Liquidity/AddCorporateContributor`,
            payload
        );
    }

    addIndividualContributor(payload: IndividualContributorRequest): Observable<ApiResponse<boolean>> {
        return this.http.post<ApiResponse<boolean>>(
            `${this.apiUrl}/Liquidity/AddIndividualContributor`,
            payload
        );
    }

    updateCorporateContributor(payload: CorporateContributorRequest): Observable<ApiResponse<boolean>> {
        return this.http.put<ApiResponse<boolean>>(
            `${this.apiUrl}/Liquidity/UpdateCorporateContributor`,
            payload
        );
    }

    updateIndividualContributor(payload: IndividualContributorRequest): Observable<ApiResponse<boolean>> {
        return this.http.put<ApiResponse<boolean>>(
            `${this.apiUrl}/Liquidity/UpdateIndividualContributor`,
            payload
        );
    }
}